var exports = {
  "kL": "ServerTagProfileSection.module__container___Sm9Faj",
  "r9": "ServerTagProfileSection.module__disabled___Sm9Faj",
  "aK": "ServerTagProfileSection.module__hint___Sm9Faj",
  "wV": "ServerTagProfileSection.module__optionRow___Sm9Faj",
  "Wz": "ServerTagProfileSection.module__optionRowNone___Sm9Faj",
  "XN": "ServerTagProfileSection.module__guildAvatar___Sm9Faj",
  "oM": "ServerTagProfileSection.module__guildAvatarPlaceholder___Sm9Faj",
  "ed": "ServerTagProfileSection.module__optionLabel___Sm9Faj",
  "Vq": "ServerTagProfileSection.module__tagPreview___Sm9Faj",
  "_r": "ServerTagProfileSection.module__tagPreviewText___Sm9Faj",
};

module.exports = exports;
